module.exports = __webpack_public_path__ + "static/media/image-icon.e4047cae.svg";